import i18n from '../../language/index'
import { create_title } from '@/base/titleData'
import linkData from '@/base/linkData'
import img_effects from '@/base/img_effects'

export default {
  img_effects,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  mb_infor: {
    marginTop: '0',
    marginRight: '0',
    marginBottom: '0',
    marginLeft: '0'
  },
  pc_widgets_infor: {
    title: create_title('Graphic display'),
    imgWidth: 50
  },
  mb_widgets_infor: {
    title: create_title('Graphic display'),
    imgWidth: 50
  },
  listArr: {
    moduleStyle: 0,
    // text: '请点击“编辑模块”修改内容...',
    richText: i18n.t('widgets_basic_rich_text_style_2814'),
    link: linkData,
    imgURL: 'https://staticjs.71360.com/3/static/txys-001/image/video.jpg',
    desc: '',
    thumbnailWidth: ''
  }
}



// WEBPACK FOOTER //
// ./src/widgets/basic_rich_text/style.js